import { PopoverButton } from '@headlessui/react';
import clsx from 'clsx';
import { useAtomValue, useSetAtom } from 'jotai';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import { periodsTranslation } from '@/lib/periods';

import { DatepickerPopover } from '@/components/base/Datepicker/DatepickerComponent';
import type { DatepickerRangeAtomImmer } from '@/components/base/Datepicker/DatepickerComponent/Atoms/datepickerAtom';
import { datepickerAtom } from '@/components/base/Datepicker/DatepickerComponent/Atoms/datepickerAtom';
import { updatePeriodAtom } from '@/components/base/Datepicker/DatepickerComponent/Atoms/periodsAtom';
import Icon from '@/components/base/Icon';
import { DatepickerCalendar } from '@/components/base/Datepicker/DatepickerComponent/components/DatepickerCalendar';
import { DatepickerPanel } from '@/components/base/Datepicker/DatepickerComponent/components/DatepickerPanel';
import { TabItem } from '@/components/composite/PeriodPicker/components/PeriodTabs/TabItem';

export function CustomTab() {
    const { t } = useTranslation();
    const datepickerData = useAtomValue(datepickerAtom as DatepickerRangeAtomImmer);
    const updatePeriod = useSetAtom(updatePeriodAtom);
    const isActive = datepickerData.period === 'custom';

    return (
        <DatepickerPopover
            popperOptions={{
                modifiers: [
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: ['auto']
                        }
                    }
                ]
            }}>
            {({ open, setReferenceElement, setPopperElement, styles, attributes }) => (
                <>
                    <PopoverButton
                        as={TabItem}
                        ref={setReferenceElement}
                        data-testid={`period-custom${isActive ? '-active' : ''}`}
                        isActive={isActive}
                        onClick={() => updatePeriod('custom')}>
                        <span>{t(periodsTranslation.custom)}</span>
                        <Icon
                            icon={open ? 'chevron-top' : 'chevron-bottom'}
                            className={clsx('text-xs text-icoGray-400', {
                                'dark:text-icoDarkMode-wolf': !isActive,
                                'dark:text-icoDarkMode-beton': isActive
                            })}
                        />
                    </PopoverButton>
                    <DatepickerPanel
                        open={open}
                        styles={styles}
                        attributes={attributes}
                        setPopperElement={setPopperElement}>
                        <DatepickerCalendar />
                    </DatepickerPanel>
                </>
            )}
        </DatepickerPopover>
    );
}
